// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2dad7a07","211":"cc764958","358":"3e07b24d","453":"4148a101","492":"fdb6e9e2","503":"294748e3","737":"9b0a0d94"}[chunkId] + ".chunk.js";
};